import { getCookie } from '../../utils';
import { GET_BUILDING_BY_ID, GET_TOUR_TYPES_BY_APARTMENT } from '../Constant';
import { get, put } from '../networkClient';
import { ToastFireAction } from './Toast';

const BuildingById = data => ({
  type: GET_BUILDING_BY_ID,
  data: data
});

const SetApartmentTourTypes = data => ({
  type: GET_TOUR_TYPES_BY_APARTMENT,
  data: data
});

const authorization = getCookie('rb_access_token');

export const BuildingByIdAction = id => async dispatch => {
  await get('/apartment', { id: id }).then(resp => {
    dispatch(BuildingById(resp.data));
  });
};
export const callToTextUpdate = BuildingData => async dispatch => {
  const body = BuildingData;
  await put(`/apartment/update`, body)
    .then(resp => {
      if (resp.status === 200) {
        dispatch(ToastFireAction(true, 'success', 'File Uploaded'));
        dispatch(BuildingByIdAction(body.id));
      }
    })
    .catch(error => {
      ToastFireAction(true, 'error', 'Error occurred in building Updation');
    });
};

export const PurchaseNumber = data => async dispatch => {
  await put('/apartment/phone-new', data)
    .then(resp => {
      if (resp.status === 200) {
        return dispatch(ToastFireAction(true, 'success', 'Phone No Updated'));
      }
    })
    .catch(error => {
      ToastFireAction(true, 'error', 'Error occured in Phone Update');
    });
};

export const fetchAvailableTourTypesByApartment = id => async dispatch => {
  await get(
    `/tours/type/${id}`,
    {},
    {
      'Content-Type': 'application/json',
      Authorization: authorization
    },
    true,
    true
  ).then(resp => {
    if (resp.status === 200) {
      const respondeData = resp?.data?.data;
      const { tourTypes } = respondeData || {};
      dispatch(SetApartmentTourTypes(tourTypes));
    } else {
      dispatch(
        ToastFireAction(true, 'error', 'Error while fetching tour types')
      );
      dispatch(SetApartmentTourTypes([]));
    }
  });
};
